import { Box } from "@mui/material";

export default function FormRow({ children, sx, ...props }) {
    return (
        <Box sx={{ display: "flex", flexBasis: "100%", flexWrap: "wrap", gap: 2, ...sx }} {...props}>
            {children}
        </Box>
    );
}
